var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckboxOutline = function SvgCheckboxOutline(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9279_1327)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 22V8H8V22H22ZM8 6H22C23.1 6 24 6.9 24 8V22C24 23.1 23.1 24 22 24H8C6.9 24 6 23.1 6 22V8C6 6.9 6.9 6 8 6ZM10 14.9992L13.6364 19L13.6364 19L13.6364 19L13.6364 19L13.6367 18.9996L20 12.5L19.0909 11.5L13.6616 17.0129L10.9638 14L10 14.9992Z",
    fill: "var(--iconColor, currentColor)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 4V2H2V16H4V18H2C0.9 18 0 17.1 0 16V2C0 0.9 0.9 0 2 0H16C17.1 0 18 0.9 18 2V4H16Z",
    fill: "var(--iconColor, currentColor)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9279_1327"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "var(--iconColor, currentColor)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckboxOutline);
export { ForwardRef as ReactComponent };